<template>
    <b-modal ref="modal" size="lg" id="modal_vue" lazy hide-footer>
    <!--<b-modal ref="modal" size="lg" id="modal_vue" lazy hide-footer @hide="checkFields">-->
        <div v-html="modal_testo" ref="inn" class="row"></div>
    </b-modal>
</template>

<script>
    // import {events} from './events'

    export default {
        name: "Modals",
        data: function () {
            return {
                modal_testo: ''
            }
        },
        mounted: function () {
            // events.$on('show', this.show);
        },
        methods: {
            // show: function (data) {
            //     console.log(data)
            //     return
            //
            //     if (evt) evt.preventDefault();
            //
            //     this.$refs.modal.show();
            //     this.modal_testo = '<div class="k-loader__wrapper"><div class="k-loader"><div></div><div></div><div></div><div></div></div></div>';
            //     this.$http.get(url)
            //         .then(
            //             function (response) {
            //                 var modal = this.$refs.inn;
            //                 this.insertAndExecute(modal, response.data);
            //             }.bind(this)
            //         )
            //         .catch(function (error) {
            //             console.log(error);
            //         });
            // },
            // insertAndExecute: function (domelement, text) {
            //     domelement.innerHTML = text;
            //     var scripts = [];
            //
            //     ret = domelement.childNodes;
            //     for (var i = 0; ret[i]; i++) {
            //         if (scripts && this.nodeName(ret[i], "script") && (!ret[i].type || ret[i].type.toLowerCase() === "text/javascript")) {
            //             scripts.push(ret[i].parentNode ? ret[i].parentNode.removeChild(ret[i]) : ret[i]);
            //         }
            //     }
            //
            //     for (script in scripts) {
            //         this.evalScript(scripts[script]);
            //     }
            // },
            // nodeName: function (elem, name) {
            //     return elem.nodeName && elem.nodeName.toUpperCase() === name.toUpperCase();
            // },
            // evalScript: function (elem) {
            //     data = (elem.text || elem.textContent || elem.innerHTML || "");
            //
            //     var head = document.getElementsByTagName("head")[0] || document.documentElement,
            //         script = document.createElement("script");
            //     script.type = "text/javascript";
            //     script.appendChild(document.createTextNode(data));
            //     head.insertBefore(script, head.firstChild);
            //     head.removeChild(script);
            //
            //     if (elem.parentNode) {
            //         elem.parentNode.removeChild(elem);
            //     }
            // }, checkFields: function (evt) {
            //     var inputs = this.$refs.modal.$el.querySelectorAll('input');
            //     if (!inputs.length) return;
            //
            //     var isCompiled = false;
            //     for (var i = 0; i < inputs.length; i++) {
            //         if (inputs[i].type === 'text' && inputs[i].value !== '' && input[i].disabled === false) {
            //             isCompiled = true;
            //             break;
            //         }
            //     }
            //
            //     if (isCompiled) {
            //         let r = confirm('Hai già compilato alcuni campi, sei sicuro di voler chiudere il form?');
            //         if (!r) evt.preventDefault();
            //     }
            // }
        }
    }
</script>